import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader from './AppHeader';
import Option from './Option';

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            LOADING: true,
            Notifications: false,
            Del_City: false,
            Del_Area: false,
            DelCity: [],
            DelArea: [],
            delSET: false
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmLocate')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmLocate')[0].classList.add('was-validated');

        if(err==0)
        {
            //$('#ModalLoadingAlert').modal('show');
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://www.peepkitchen.in/peep/pwa/api/locate_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {
                //console.log(result);
                //alert(result);
                let notify = '';
                if(result.err!='')
                {
                    if(result.err=='1') notify = 'Delivery Circle Field is Empty';
                    else if(result.err=='2') notify = 'Area/Near by Locality Field is Empty';
                    else if(result.err=='3') notify = 'No Restaurant Found For The Chosen Area';
                    else if(result.err=='4') notify = 'Invalid Access Detected';
                }

                let delcity = false;
                let delarea = false;

                let restaurant = result.restaurant;
                if(restaurant!='' && restaurant!=undefined)
                {
                    localStorage.setItem('REST',restaurant);
                    
                    delcity = result.del_city;
                    delarea = result.del_area;
                    localStorage.setItem('delCity',delcity);
                    localStorage.setItem('delArea',delarea);
                }

                that.setState({ Notifications: notify, Del_City:delcity, Del_Area:delarea, delSET:true });
                ///$('#ModalLoadingAlert').modal('hide');
                if(notify!='')
                    $('#ModalAlert').modal('show');
          });
        }
    }

    fetchCircle(type,id) {
        var that = this;
        fetch('https://www.peepkitchen.in/peep/pwa/api/deliveryarea_api.php?type='+type+'&id='+id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            that.setState({ DelCity: result.del_circle, LOADING:false});
        });
    }

    handlecircleChange = (e) => {
        //$('#ModalLoadingAlert').modal('show');
        e.preventDefault();

        var type = 'AREA';
        var id = event.target.value;
        var that = this;
        fetch('https://www.peepkitchen.in/peep/pwa/api/deliveryarea_api.php?type='+type+'&id='+id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            that.setState({ DelArea: result.del_area});
            //$('#ModalLoadingAlert').modal('hide');
        });
    }    

    componentWillMount() {
        this.fetchCircle('CITY','0');
    }

    render() { 
        
        //localStorage.removeItem('REST');
        //localStorage.removeItem('delCity');
        //localStorage.removeItem('delArea');

        if(this.state.delSET==true)
        {
            if(localStorage.getItem('REST') && localStorage.getItem('REST')!=null)
            {
                return (<Redirect to={'/home'}/>)
            }
        }

        /*if(localStorage.getItem('REST') && localStorage.getItem('REST')!=null)
        {
	        return (<Redirect to={'/home'}/>)
        }*/
        
        let AppHeaderClass = 'appHeader bg-primary text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/';
        let AppHeaderTitle = 'Delivery Circle';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
    
        var city = this.state.DelCity;
        var arr = [];
        Object.keys(city).forEach(function(key) {
            arr.push(city[key]);
        });
        
        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} />
                <div id="appCapsule">
                    <br />
                    <div className="row">
                        <div className="col-2"></div>
                            <div className="col-8 align-content-center">
                                <img src="/assets/img/location.png" alt="location" className="center-image" />
                            </div>
                        <div className="col-2"></div>
                    </div>
                    <div className="login-form">
                        <div className="section mt-2 mb-5">
                            <form id="frmLocate" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                                <input type="hidden" value="LOCATE" className="form-control" name="mode" id="mode" />
                                <div className="form-group boxed">
                                    <div className="input-wrapper">
                                        <select className="form-control custom-select" id="cmbdelcity" name="cmbdelcity" required onChange={this.handlecircleChange}>
                                            <option value="">Delivery Circle</option>
                                            {arr.map(post =>
                                                <optgroup key={post.name} label={post.name}>
                                                    <Option post={post.child}/>
                                                </optgroup>
                                            )}
                                        </select>
                                        <div className="valid-feedback">&nbsp;</div> 
                                        <div className="invalid-feedback">Please choose the delivery circle.</div> 
                                    </div>
                                </div>
                                <div className="form-group boxed">
                                    <div className="input-wrapper">
                                        <select className="form-control custom-select" id="cmbdelarea" name="cmbdelarea" required>
                                            <option value="">Area / Near by Locality</option>
                                                <Option post={this.state.DelArea}/>
                                        </select>
                                        <div className="valid-feedback">&nbsp;</div> 
                                        <div className="invalid-feedback">Please choose the area/near by locality.</div> 
                                    </div>
                                </div>
                                <div className="form-button-group">
                                    <button type="submit" className="btn btn-primary btn-block btn-lg">SUBMIT</button>
                                </div>
                            </form>
                            <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-icon text-danger">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </div>
                                        <div className="modal-body"> 
                                                {this.state.Notifications} 
                                        </div>
                                        <div className="modal-footer">
                                            <div className="btn-inline"> 
                                                <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
      
export default Register;


// WEBPACK FOOTER //
// ./src/components/Locate.js